import CalculateIcon from '@mui/icons-material/Calculate';

import BudgetList from './BudgetList';
import BudgetCreate from './BudgetCreate';
import BudgetShow from './BudgetShow';
import BudgetEdit from './BudgetEdit';

const budgets = {
	list: BudgetList,
	create: BudgetCreate,
	show: BudgetShow,
	edit: BudgetEdit,
	icon: CalculateIcon
};

export default budgets;
